import React, { useEffect, useMemo, useState } from 'react';

import {
  Card,
  CardBody,
  Col,
  Container,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
} from 'reactstrap';

import classnames from 'classnames';
import { Link, useParams } from 'react-router-dom';
import { has, every, partial, isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { useMutation, useQueryClient } from 'react-query';

import { loginUser, setMember, editMember } from 'store/actions';
import { useRole } from 'hooks/useRole';
import notify from 'utils/notify';
import { getAllRelationshipsApi } from 'api/report';
import {
  getMemberByIdApi, updateMember,
  getAttachmentApi,
  uploadDepeMedia,
  getNextOfKinByIdApi,
  updateNextOfKin,
} from 'api/member';
// import AddressTab from './wizard/AddressTab';
import MemberDetailsTab from './wizard/MemberDetailsTab';
import AddNextOfKin from './wizard/AddNextOfKin';
import AddDependants from './wizard/AddDependant';
import CompleteRegister from './wizard/CompleteRegister';
import ConsentGate from './wizard/ConsentGate';
import './wizard/wizard.scss';
import { getDependentsByIdApi } from 'api/claim';
import { recordMemberConsent } from 'api/member';

const FormWizard = () => {
  const {
    isFacilitator,
    isSiteCord,
    isCountyCoordinator,
    isClusterLeader,
    isFinance,
    isDirector,
    isAdmin,
    isSuperAdmin,
    isData,
    addresses,
  } = useRole();
  const [pages, setPages] = useState(0);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [memberId, setMemberId] = useState(id);
  const [memberData, setMemberData] = useState(null);
  const [nextOfKin, setNextOfKin] = useState(null);
  // New registrations persist nothing until the declaration is signed at step 4.
  const [pendingNok, setPendingNok] = useState(null);
  const [pendingDependants, setPendingDependants] = useState([]);
  const [notNew, setNotNew] = useState(!!id);
  const [consent, setConsent] = useState(id ? { persisted: true } : null);

  //meta title
  document.title = 'Member Form Wizard | SUN Welfare Administration System';

  const [address, setAddress] = useState({});

  const [activeTab, setactiveTab] = useState(1);

  const [passedSteps, setPassedSteps] = useState([1]);

  const queryClient = useQueryClient();

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 6) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
    if (tab === 2) {
      //Fetch Next Of Kin
      if (memberId) {
        mutateNextOfKin({ memberId: member?.memberId, status: 'Active' });
        // mutateNextOfKin({ memberId: member?.memberId });
      }
    }
    if (tab === 3) {
      //Fetch Dependents Of Kin
      mutateDependents({ memberId: member?.memberId });
    }
    if (activeTab === 4 && tab === 5) {
      const data = {
        ...member,
        status: 'Pending',
      };
      updateMember(data)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  const {
    mutate: mutateAttachements,
    isLoading: isLoadingAttachements,
    data: attachements,
  } = useMutation((payload) => getAttachmentApi(payload), {
    onSettled: () => {
      queryClient.invalidateQueries('/um/dependent/attachment');
    },
  });

  const {
    mutate: mutateNextOfKin,
    isLoading: isLoadingNextOfKins,
    data: nextOfKins,
  } = useMutation((payload) => getNextOfKinByIdApi(payload), {
    onSuccess: (res) => {
      if (res?.length) {
        const kin = res?.find(r => r.status === 'Active');
        setNextOfKin(kin);
        kin?.nextOfKinId && mutateAttachements(kin?.nextOfKinId);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries('/um/nextofkin');
    },
  });

  const {
    mutate: mutateDependents,
    isLoading: isLoadingDependents,
    data: dependents,
  } = useMutation((payload) => getDependentsByIdApi(payload), {
    onSuccess: (res) => {
      // console.log(res);
    },
    onSettled: () => {
      queryClient.invalidateQueries('/um/dependents');
    },
  });

  const {
    mutate: mutateMember,
    isLoading: isLoadingMember,
    data: member,
  } = useMutation((payload) => getMemberByIdApi(payload), {
    onSuccess: (res) => {
      setMember(res);
      setAddress(res?.addresses?.[0]);
    },
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  const {
    mutate: mutateRelationships,
    isLoading: isLoadingRelationships,
    data: relationshipsData,
  } = useMutation((payload) => getAllRelationshipsApi(payload), {
    onSettled: () => {
      queryClient.invalidateQueries('get-all-counties');
    },
  });

  useEffect(() => {
    memberId && mutateMember(memberId);
  }, [memberId]);

  useEffect(() => {
    mutateRelationships();
  }, []);

  const onChange = (e, key) => {
    const value = e.target.value;
    if (key === 'nextOfKin') {
      dispatch(editMember({ [e.target.name]: value }, 'nextOfKin'));
    } else if (key === 'address') {
      dispatch(editMember({ [e.target.name]: value }, 'address'));
    } else {
      dispatch(editMember({ [e.target.name]: value }, 'member'));
    }
  };

  const onChangeAddress = (values) => {
    setAddress({ ...address, ...values });
  };

  const onGoNext = () => {
    toggleTab(activeTab + 1);
  };

  const onChangeMemberId = (id) => {
    setMemberId(id);
  };
  const onSetMember = (data) => {
    setMemberData(data);
  };
  const onStageNextOfKin = (payload, file) => {
    setPendingNok({ payload, file });
    setNextOfKin(payload);
  };
  const onStageDependant = (payload, file) => {
    const key = (d) =>
      `${[d.firstName, d.lastName].join(' ').replace(/\s+/g, ' ').trim().toLowerCase()}|${d.dob}`;
    if (pendingDependants.some((d) => key(d.payload) === key(payload))) {
      notify.warning(
        'Already added',
        `${payload.firstName} ${payload.lastName} is already in this member's dependants list.`,
      );
      return false;
    }
    setPendingDependants((prev) => [...prev, { payload, file }]);
    return true;
  };

  const persistConsent = async (newMemberId) => {
    if (!consent || consent.persisted) return;
    await recordMemberConsent({
      memberId: newMemberId,
      facilitatorId: Number(localStorage.getItem('userId')) || 0,
      consentDocumentId: consent.consentDocumentId,
      channel: 'FACILITATOR',
      consentGiven: true,
      deviceId: window.navigator?.userAgent || '',
      remarks: '',
    });
    setConsent({ ...consent, persisted: true });
  };
  const isDisabled =
    activeTab === 4 ||
    (activeTab === 1 && isEmpty(member)) ||
    (activeTab === 2 && !nextOfKin) ||
    (activeTab === 1 &&
      !every(
        ['constituencyId', 'countyId', 'wardId', 'regionId'],
        partial(has, notNew ? member?.addresses[0] : {}),
      )) ||
    (activeTab === 2 &&
      !every(
        ['constituencyId', 'countyId', 'wardId', 'regionId'],
        partial(has, notNew ? member?.addresses[0] : {}),
      ));
  const steps = [
    // { step: 1, label: 'Address Details', check: () => true, disableCheck: 1 },
    {
      step: 1,
      label: 'Member Details',
      check: () => address?.wardId,
      disableCheck: 1,
    },
    {
      step: 2,
      label: 'Next Of Kin Details',
      check: () => address?.wardId && (member?.id || memberData),
      disableCheck: 2,
    },
    {
      step: 3,
      label: 'Dependant Details',
      check: () => address?.wardId && (member?.id || memberData),
      disableCheck: 3,
    },
    { step: 4, label: 'Confirm', check: () => true, disableCheck: 4 },
  ];

  const renderNavItem = (step, label, check, disableCheck) => (
    <NavItem
      className={classnames({ current: activeTab === step, done: step < activeTab })}
      key={step}
    >
      <NavLink
        className={classnames({ active: activeTab === step })}
        onClick={() => check() && setactiveTab(step)}
        disabled={!(passedSteps || []).includes(disableCheck)}
      >
        <span className="number">
          {step < activeTab ? <i className="mdi mdi-check" /> : step}
        </span>
        {label}
      </NavLink>
    </NavItem>
  );

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title="Member" breadcrumbItem="New Member" />
        <Row>
          <Col lg="12">
            <Card className="mb-3">
              <CardBody className="py-3 d-flex flex-wrap align-items-center justify-content-between gap-2">
                <div>
                  <h5 className="mb-0 fw-semibold">{id ? 'Edit member' : 'New member'}</h5>
                  {consent && (
                    <small className="text-muted">
                      Step {activeTab} of {steps.length}: {steps[activeTab - 1]?.label}
                    </small>
                  )}
                </div>
                <Button type="button" color="light" onClick={() => window.history.back()}>
                  <i className="bx bx-arrow-back align-middle me-1" />
                  Back
                </Button>
              </CardBody>
            </Card>
            <Card className="member-wizard">
              <CardBody>
                {!consent ? (
                  <ConsentGate onAccept={setConsent} />
                ) : (
                  <div className="wizard clearfix">
                  <div className="steps clearfix">
                    <ul>
                      {steps.map(({ step, label, check, disableCheck }) =>
                        renderNavItem(step, label, check, disableCheck),
                      )}
                      {/* <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1)
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="number">1.</span> Member Region
                          </NavLink>
                        </NavItem> */}
                      {/* <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              address?.wardId ? setactiveTab(1) : () => { }
                            }}
                            disabled={!(passedSteps || []).includes(2)}
                          >
                            <span className="number">1.</span> Member Details
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              address?.wardId && member?.id && setactiveTab(2)
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="number">2.</span> Next Of Kin Details
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 3 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 3 })}
                            onClick={() => {
                              address?.wardId && member?.id && setactiveTab(3)
                            }}
                            disabled={!(passedSteps || []).includes(3)}
                          >
                            <span className="number">3.</span> Dependant Details
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 4 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 4 })}
                            onClick={() => {
                              setactiveTab(4)
                            }}
                            disabled={!(passedSteps || []).includes(4)}
                          >
                            <span className="number">4.</span> Confirm
                          </NavLink>
                        </NavItem> */}
                    </ul>
                  </div>
                  <div className="content clearfix">
                    <TabContent activeTab={activeTab} className="body">
                      {/* <TabPane tabId={1}>
                        <AddressTab isNew={notNew} onChangeAddress={onChangeAddress} member={member} />
                      </TabPane> */}
                      <TabPane tabId={1}>
                        <MemberDetailsTab
                          onChange={onChange}
                          member={member}
                          onChangeMemberId={onChangeMemberId}
                          onNext={onGoNext}
                          address={notNew ? member?.address : address}
                          onSetMember={onSetMember}
                          mutateMember={mutateMember}
                        />
                      </TabPane>
                      <TabPane tabId={2}>
                        <AddNextOfKin
                          onNext={onGoNext}
                          onChange={onChange}
                          onChangeMemberId={onChangeMemberId}
                          member={member}
                          memberData={memberData}
                          kin={nextOfKin}
                          setKin={setNextOfKin}
                          mutateMember={mutateMember}
                          attachements={attachements}
                          relationshipsData={relationshipsData}
                          onStageNextOfKin={onStageNextOfKin}
                        />
                      </TabPane>
                      <TabPane tabId={3}>
                        <AddDependants
                          onChange={onChange}
                          member={member}
                          relationshipsData={relationshipsData}
                          dependents={member?.memberId ? dependents : pendingDependants.map((d) => d.payload)}
                          onStageDependant={onStageDependant}
                          onNext={onGoNext}
                          queryClient={queryClient}
                          mutate={mutateDependents}
                        />
                      </TabPane>
                      <TabPane tabId={4}>
                        <CompleteRegister
                          member={member}
                          consentDocument={consent}
                          memberData={memberData}
                          pendingNok={pendingNok}
                          pendingDependants={pendingDependants}
                          onMemberCreated={persistConsent}
                          onMemberId={onChangeMemberId}
                        />
                      </TabPane>
                    </TabContent>
                  </div>
                  <div className="wizard-footer d-flex justify-content-between align-items-center gap-2 mt-4 pt-3 border-top">
                    <Button
                      type="button"
                      color="light"
                      disabled={activeTab === 1}
                      onClick={() => toggleTab(activeTab - 1)}
                    >
                      <i className="mdi mdi-chevron-left me-1" />
                      Previous
                    </Button>
                    {activeTab < 4 ? (
                      <Button
                        type="button"
                        color="primary"
                        disabled={isDisabled}
                        onClick={() => !isDisabled && toggleTab(activeTab + 1)}
                      >
                        Next step
                        <i className="mdi mdi-chevron-right ms-1" />
                      </Button>
                    ) : (
                      <span />
                    )}
                  </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FormWizard;
